<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Assuntos">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="12">
                <div class="form-label-group">
                  <b-form-input
                    id="id"
                    placeholder="ID"
                    v-model="form._id"
                    disabled
                  />
                  <label for="id">ID</label>
                </div>
              </b-col> -->
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                    <v-select
                      id="origin-list"
                      v-model="originModel"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :options="origins"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6"></b-col>
                            
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="name" placeholder="Nome" v-model="form.name" />
                  <label for="name">Nome</label>
                </div>
              </b-col>
              
              <b-col md="12"></b-col>
              <b-col md="12">
                <div class="form-label-group">
                  <label for="channels-list">Canal</label>
                  <b-form-group label="Canal" label-for="channels-list">
                    <v-select
                      id="channels-list"
                      v-model="form.channels"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :closeOnSelect="false"
                      :options="channels"
                    >
                      <template v-slot:option="item">
                        <p><b>{{item.name}}</b></p>
                        <!-- <p><small>Origens: {{item.originsName.join(', ')}}</small></p> -->
                      </template>
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="12">
                <div class="form-label-group">
                  <label for="content-list">Conteudo</label>
                  <b-form-group label="Conteudo" label-for="content-list">
                    <v-select
                      id="content-list"
                      v-model="form.content"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :closeOnSelect="false"
                      :options="content"
                    >
                      <template v-slot:option="item">
                        <p><b>{{item.name}}</b></p>
                        <p><small>Origens: {{item.originsName.join(', ')}}</small></p>
                      </template>
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>

              <b-col md="12">
                <div class="form-label-group">
                  <label for="origin-list">Tópico</label>
                  <b-form-group label="Tópico" label-for="origin-list">
                    <v-select
                      id="origin-list"
                      v-model="form.topic"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      multiple
                      :closeOnSelect="false"
                      label="name"
                      :options="topic"
                    >
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="general"
                    name="general"
                    v-model="form.general"
                  >
                    Geral
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col md="12" v-if="form.general">
                <div class="form-label-group">
                  <label for="content-list">Assunto para auto-selecionar</label>
                  <b-form-group label="Assunto para auto-selecionar" label-for="content-list">
                    <v-select
                      id="content-list"
                      v-model="form.general_autoselect"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      multiple
                      :closeOnSelect="false"
                      :options="general_autoselect"
                    >
                      <template v-slot:option="item">
                        <p><b>{{item.name}}</b></p>
                        <p><small>Origens: {{item.originsName.join(', ')}}</small></p>
                      </template>
                      <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                    </v-select>
                  </b-form-group>
                </div>
              </b-col>
              <b-col md="6"></b-col>

              <b-col md="12"><hr /></b-col>
              <b-col md="12" style="margin-bottom: 10px"><h4>Legado</h4></b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input
                    id="acronym"
                    placeholder="Sigla"
                    v-model="form.acronym"
                  />
                  <label for="acronym">Sigla</label>
                </div>
              </b-col>
              <b-col md="12"><hr /></b-col>
              <b-col md="12" style="margin-bottom: 10px"><h4>Plataforma</h4></b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input
                    id="code"
                    placeholder="Código"
                    v-model="form.code"
                  />
                  <label for="code">Código</label>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input
                    id="mnemonic"
                    placeholder="Minemonico"
                    v-model="form.mnemonic"
                  />
                  <label for="mnemonic">Minemonico</label>
                </div>
              </b-col>

              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input
                    id="icon"
                    placeholder="Icone"
                    v-model="form.icon"
                  />
                  <label for="icon">Icone</label>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input id="order" placeholder="Ordem" v-model="form.order" />
                  <label for="order">Ordem do menu</label>
                </div>
              </b-col>

              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelPtBr" placeholder="Label PtBr" v-model="form.labelPtBr" />
                  <label for="labelPtBr">Label PtBr</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelEnEu" placeholder="Label EnEu" v-model="form.labelEnEu" />
                  <label for="labelEnEu">Label EnEu</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelEsEs" placeholder="Label EsEs" v-model="form.labelEsEs" />
                  <label for="labelEsEs">Label EsEs</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelEsAr" placeholder="Label EsAr" v-model="form.labelEsAr" />
                  <label for="labelEsAr">Label EsAr</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelPtPt" placeholder="Label PtPt" v-model="form.labelPtPt" />
                  <label for="labelPtPt">Label PtPt</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="labelZhCn" placeholder="Label ZhCn" v-model="form.labelZhCn" />
                  <label for="labelZhCn">Label ZhCn</label>
                </div>
              </b-col>
              
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="isCommodity"
                    name="isCommodity"
                    v-model="form.isCommodity"
                  >
                    Commodity/Dashboard
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="enableInPublicArea"
                    name="enableInPublicArea"
                    v-model="form.enableInPublicArea"
                  >
                    Habilitar na área pública
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="displayInMenu"
                    name="displayInMenu"
                    v-model="form.displayInMenu"
                  >
                    Mostrar no menu
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col md="12"><hr /></b-col>
              <b-col md="12" style="margin-bottom: 10px"><h4>Aplicativo</h4></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameApp" placeholder="Nome" v-model="form.nameApp" />
                  <label for="nameApp">Nome no app</label>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input
                    id="filter"
                    placeholder="Filtro"
                    v-model="form.filter"
                  />
                  <label for="filter">Filtro</label>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input id="orderApp" placeholder="Ordem Aplicativo" v-model="form.orderApp" />
                  <label for="orderApp">Ordem App</label>
                </div>
              </b-col>
             <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="public"
                    name="public"
                    v-model="form.public"
                  >
                    Público
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- <b-col md="12"><hr /></b-col>
              <b-col md="12" style="margin-bottom: 10px"><h4>WDMA</h4></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="menu_section" placeholder="Sessão Menu" v-model="form.menu_section" />
                  <label for="menu_section">Sessão Menu</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="wdma_menu_name" placeholder="Identificador menu" v-model="form.wdma_menu_name" />
                  <label for="wdma_menu_name">Identificador menu</label>
                </div>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="wdma_menu_hasContentViewer"
                    name="wdma_menu_hasContentViewer"
                    v-model="form.wdma_menu_hasContentViewer"
                  >
                    Content viewer
                  </b-form-checkbox>
                </b-form-group>
              </b-col> -->

              <!-- <b-col md="12"><hr /></b-col> -->
              
             <!-- <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="public"
                    name="public"
                    v-model="form.public"
                  >
                    Público
                  </b-form-checkbox>
                </b-form-group>
              </b-col> -->
              

              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="enable_chart"
                    name="enable_chart"
                    v-model="form.enable_chart"
                  >
                    Exibir no gráfico
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="active"
                    name="active"
                    v-model="form.active"
                  >
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="notSendInGeneral"
                    name="notSendInGeneral"
                    v-model="form.notSendInGeneral"
                  >
                    Não enviar com geral
                  </b-form-checkbox>
                </b-form-group>
              </b-col> -->
                            
              <b-col>
                <b-button
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="onSubmit"
                >
                  Enviar
                </b-button>
                <b-button variant="danger" class="mr-1" @click="onBackPage">
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
        <b-tab title="Thumb">
          <b-row>
            <b-col md="8">
              <label for="thumb" class="mt-1">Adicione uma imagem</label>
              <b-form-file
                id="thumb"
                @change="onChangeThumb"
                accept=".jpg, .png, .jpeg"
                placeholder="Adicione uma imagem"
                drop-placeholder="Insira uma imagem"
                browse-text="Pesquisar"
              />
            </b-col>
            <b-col md="12" v-if="displayThumbPreview">
              <img :src="thumbPreviewSrc" style="width: 100px; height: 100px" />
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Rotas Plataforma-Wdma">
          <subject-register-routes
            :platformWdmaRoute="form.platformWdmaRoute"
            :countries="countries"
            @submit-route="updateRoute"
          ></subject-register-routes>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
  BFormFile,
} from "bootstrap-vue";
import subjectService from "@/providers/subjectService";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from "@/helpers/convert-datetime-helper";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
import vSelect from "vue-select";
import AppConstants from '@/appConstants';
import SubjectRegisterRoutes from './SubjectRegisterRoutes.vue';

export default {
  props: {},
  data() {
    return {
      dataID: null,
      origins: [],
      topic: [],
      content: [],
      general_autoselect: [],
      originModel: [],
      countries: [],
      channels: [],
      form: {
        _id: "",
        name: "",
        nameApp: "",
        labelPtBr: '',
        labelEnEu: '',
        labelEsEs: '',
        labelEsAr: '',
        labelPtPt: '',
        labelZhCn: '',
        mnemonic: '',
        acronym: '',
        filter: '',
        icon: '',
        code: 0,
        order: 1,
        orderApp: 1,
        public: false,
        isCommodity: false,
        enableInPublicArea: false,
        displayInMenu: true,
        active: true,
        enable_chart: false,
        general: false,
        notSendInGeneral: false,
        origins: "",
        content: "",
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
        file: null,
        topic: [],
        general_autoselect: [],
        platformWdmaRoute: [],
        channels: []
      },
      displayThumbPreview: false,
      thumbPreviewSrc: "",
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Novo Assunto');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
    }

    this.loadData();
  },
  watch: {
    "form.general" (val) {
      if (val) {
        this.loadGeneralSubjects();
      }
    },
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Novo Assunto');
      }
    },
    "form.content"(val) {
      if (val.findIndex(item => item.id == AppConstants.DROPDOWN_ALL_OPTION.id) >= 0) {
        this.form.content = [];
        this.form.content = JSON.parse(JSON.stringify(this.content));
        this.form.content.shift();
      }
    },
    "form.channels"(val) {
      if (val.findIndex(item => item.id == AppConstants.DROPDOWN_ALL_OPTION.id) >= 0) {
        this.form.channels = [];
        this.form.channels = JSON.parse(JSON.stringify(this.channels));
        this.form.channels.shift();
      }
    },
    "form.general_autoselect"(val) {
      console.log(val);
      if (val.findIndex(item => item.id == AppConstants.DROPDOWN_ALL_OPTION.id) >= 0) {
        this.form.general_autoselect = [];
        this.form.general_autoselect = JSON.parse(JSON.stringify(this.general_autoselect));
        this.form.general_autoselect.shift();
      }
    },
    originModel() {
      this.loadContent();
    }
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    updateRoute(item) {
      // console.log('updateRoute: ', item)
      const index = this.form.platformWdmaRoute.findIndex(p => p.country.id == item.country.id);
      if (index < 0) {
        this.form.platformWdmaRoute.push(item);
      } else {
        this.form.platformWdmaRoute[index] = item;
      }
    },
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_SUBJECT);
    },
    onSubmit() {
      const formData = new FormData();
      formData.append('thumb', this.form.file);
      formData.append('_id', this.form._id);
      formData.append('name', this.form.name);
      formData.append('nameApp', this.form.nameApp);
      formData.append('labelPtBr', this.form.labelPtBr);
      formData.append('labelEnEu', this.form.labelEnEu);
      formData.append('labelEsEs', this.form.labelEsEs);
      formData.append('labelEsAr', this.form.labelEsAr);
      formData.append('labelPtPt', this.form.labelPtPt);
      formData.append('labelZhCn', this.form.labelZhCn);
      formData.append('mnemonic', this.form.mnemonic);
      formData.append('acronym', this.form.acronym);
      formData.append('icon', this.form.icon);
      formData.append('code', this.form.code);
      formData.append('filter', this.form.filter);
      formData.append('order', this.form.order);
      formData.append('orderApp', this.form.orderApp);
      formData.append('public', this.form.public);
      formData.append('active', this.form.active);
      formData.append('enable_chart', this.form.enable_chart);
      formData.append('general', this.form.general);
      // formData.append('menu_section', this.form.menu_section);
      // formData.append('wdma_menu_name', this.form.wdma_menu_name);
      // formData.append('wdma_menu_hasContentViewerv', this.form.wdma_menu_hasContentViewerv);
      // formData.append('notSendInGeneral', this.form.notSendInGeneral);
      formData.append('isCommodity', this.form.isCommodity);
      formData.append('enableInPublicArea', this.form.enableInPublicArea);
      formData.append('displayInMenu', this.form.displayInMenu);
      if (this.originModel.length > 0) {
        for (let index = 0; index < this.originModel.length; index++) {
          formData.append(`origins[${index}]`, this.originModel[index].id);
        }
        // formData.append("origins",this.form.origins.map((item) => item.id));
      }
      if (this.form.content.length > 0) {
        for (let index = 0; index < this.form.content.length; index++) {
          formData.append(`content[${index}]`, this.form.content[index].id);
        }
      }
      if (this.form.general_autoselect.length > 0) {
        for (let index = 0; index < this.form.general_autoselect.length; index++) {
          formData.append(`general_autoselect[${index}]`, this.form.general_autoselect[index].id);
        }
      }
      if (this.form.topic.length > 0) {
        for (let index = 0; index < this.form.topic.length; index++) {
          formData.append(`topic[${index}]`, this.form.topic[index].id);
        }
      }
      if (this.form.channels.length > 0) {
        for (let index = 0; index < this.form.channels.length; index++) {
          formData.append(`channels[${index}]`, this.form.channels[index].id);
        }
      }
      if (this.form.platformWdmaRoute.length > 0) {
        for (let index = 0; index < this.form.platformWdmaRoute.length; index++) {
          formData.append(`platformWdmaRoute[${index}][routeName]`, this.form.platformWdmaRoute[index].routeName);
          formData.append(`platformWdmaRoute[${index}][country]`, this.form.platformWdmaRoute[index].country.id);
        }
      }
      // formData.append('origins', this.form.origins.map(item => item.id));
      
      subjectService
        .registerSubject(formData, new URLSearchParams())
        .then(() => {
          // console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    onChangeThumb(input) {
      const file = input.target.files[0];
      this.form.file = file;
      if (file) {
        this.thumbPreviewSrc = URL.createObjectURL(file);
        this.displayThumbPreview = true;
      } else {
        this.thumbPreviewSrc = "";
        this.displayThumbPreview = false;
      }
    },
    getSubjectDetail() {
      const params = new URLSearchParams();
      subjectService
        .getSubjectDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.name = res.name;
          this.form.nameApp = res.nameApp;
          this.form.labelPtBr = res.labelPtBr;
          this.form.labelEnEu = res.labelEnEu;
          this.form.labelEsEs = res.labelEsEs;
          this.form.labelEsAr = res.labelEsAr;
          this.form.labelPtPt = res.labelPtPt;
          this.form.labelZhCn = res.labelZhCn;
          this.form.mnemonic = res.mnemonic;
          this.form.acronym = res.acronym;
          this.form.icon = res.icon;
          this.form.filter = res.filter;
          this.form.code = res.code;
          this.form.order = res.order;
          this.form.orderApp = res.orderApp;
          // this.form.origins = res.origins;
          this.originModel = res.origins;
          this.form.content = res.content;
          this.form.platformWdmaRoute = res.platformWdmaRoute;
          this.form.active = res.active;
          this.form.enable_chart = res.enable_chart;
          this.form.general = res.general;
          this.form.notSendInGeneral = res.notSendInGeneral;
          this.form.general_autoselect = res.general_autoselect;
          // this.form.menu_section = res.menu_section;
          // this.form.wdma_menu_name = res.wdma_menu_name;
          // this.form.wdma_menu_hasContentViewerv = res.wdma_menu_hasContentViewerv;
          this.form.public = res.public;
          this.form.isCommodity = res.isCommodity;
          this.form.enableInPublicArea = res.enableInPublicArea;
          this.form.displayInMenu = res.displayInMenu;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
          this.form.topic = res.topic;
          this.form.channels = res.channels;

          this.loadContent();

          if (res.image_path) {
            this.thumbPreviewSrc = res.image_path;
            this.displayThumbPreview = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadContent() {
      this.topic = [];
      const params = new URLSearchParams();
      if (this.originModel.length > 0) {
        params.append(`origins`, this.originModel.map(item => item.id).join(','));
      }
      Promise.all([
        dropdownService.getContent(params),
        dropdownService.getTopic(params),
        dropdownService.getChannelByOrigin(params),
      ]).then((res) => {
        this.content = res[0];
        this.content.unshift(AppConstants.DROPDOWN_ALL_OPTION);
        this.topic = res[1];
        this.channels = res[2];
        this.channels.unshift(AppConstants.DROPDOWN_ALL_OPTION);
      })
      .catch((err) => console.log(err));
    },
    loadGeneralSubjects() {
      const params = new URLSearchParams();
      if (this.originModel.length > 0) {
        params.append(`origins`, this.originModel.map(item => item.id).join(','));
      }
      dropdownService.getAllSubjects(params)
      .then((res) => {
        this.general_autoselect = res;
        this.general_autoselect.unshift(AppConstants.DROPDOWN_ALL_OPTION);
      })
      .catch((err) => console.log(err));
    },
    loadData() {
      Promise.all([
        dropdownService.getAllOrigin(new URLSearchParams()),
        dropdownService.getAllCountries(new URLSearchParams()),
      ])
      .then((res) => {
          this.origins = res[0];
          this.countries = res[1];
          if (this.isUpdate) {
            this.getSubjectDetail();
          }
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    BFormFile,
    vSelect,
    SubjectRegisterRoutes,
    // BInputGroup,
    // BInputGroupAppend,
    // BListGroup,
    // BListGroupItem,
    // BCardText,
    // BFormTags,
    // BFormTag,
    // BFormSelect
  },
};
</script>

<style lang="scss">
.subject-badge-select {
  margin-bottom: 10px;
  .badge {
    margin: 0px 5px;
  }
}
</style>